import { MouseEvent } from "react";
import { Link } from "common/widgets/link";
import { ActionName, AVAILABLE_ACTIONS, OnClickCallback } from "./types";

const ACTION_ICONS = {
  new: "fa fa-plus",
  edit: "fa fa-edit",
  update: "fa fa-save",
  reset: "fa fa-undo",
};

const getActionLabel = (actionName: ActionName) => {
  switch (actionName) {
    case "new":
      return _("Save as New Filter");
    case "edit":
      return _("Edit Details");
    case "update":
      return _("Update Filter");
    case "reset":
      return _("Reset to Last Saved");
    default:
      return "";
  }
};

type ConfigurationActionProps = {
  actionName: ActionName;
  onClick: OnClickCallback;
};

export function ConfigurationAction({
  actionName,
  onClick,
}: Readonly<ConfigurationActionProps>) {
  if (!actionName || !AVAILABLE_ACTIONS.includes(actionName)) return null;

  const actionIcon = ACTION_ICONS[actionName];

  const onActionClick = (e: MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    onClick();
  };

  return (
    <li key={actionName}>
      <Link
        href="#"
        onClick={onActionClick}
        className="qa-btn-filter-popup dropdown-item x-filter-action-item"
      >
        {actionIcon ? <i className={actionIcon} /> : undefined}{" "}
        <span>{getActionLabel(actionName)}</span>
      </Link>
    </li>
  );
}
